import { setupWorker } from 'msw/browser';
import { authHandlers } from './handlers/auth';
import { userHandlers } from './handlers/user';
import { organizationHandlers } from './handlers/organization';
import { adminHandlers } from './handlers/admin';

// Combine all handlers
// 通过环境变量控制是否启用组织相关的 mock 接口
const mockOrganizations = import.meta.env.VITE_MOCK_ORGANIZATIONS === 'true';
export const handlers = [
  ...authHandlers,
  ...userHandlers,
  ...(mockOrganizations ? organizationHandlers : []),
  ...adminHandlers,
];

// Setup the worker with all handlers
export const worker = setupWorker(...handlers);